import * as React from 'react';
import { useId } from '../hooks/useId';
import { Field, FieldLabel, FieldInput } from '../components/Field';
import { useWatch } from '@0g/react';
export function StringField(_a) {
    var store = _a.store, name = _a.name;
    var id = useId();
    var ref = React.useRef(null);
    var onChange = React.useCallback(function (ev) {
        store[name] = ev.target.value;
        store.updated = true;
    }, [store, name]);
    useWatch(store, React.useCallback(function () {
        if (!ref.current)
            return;
        ref.current.value = store[name];
    }, [store, name, ref]));
    return (React.createElement(Field, null,
        React.createElement(FieldLabel, { htmlFor: id }, name),
        React.createElement(FieldInput, { ref: ref, onBlur: onChange, id: id })));
}
//# sourceMappingURL=StringField.js.map